







































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { TenantSettings } from "@/shared/core/services/configService";
import { ShopService } from "@/shared/core/services/shopService";
import { LocalStorage } from "@/shared/core/localStorage";
import { CustomerHelper } from "@/shared/crm/helpers/customerHelper";
import store from "@/shared/core/store";

@Component
export default class AccountMenu extends Vue {
  @Prop({ type: Boolean, default: false }) inline!: boolean;

  settings: TenantSettings = {};

  get isLoggedIn() {
    return store.state.loggedIn === true;
  }

  get firstName(): string {
    try {
      const raw = LocalStorage.getWithTimeout("cc");
      if (raw === null || raw === undefined) {
        return "";
      }
      const customer = JSON.parse(raw);
      const name = (customer.name || "").toString().trim();
      return name.split(" ")[0] || "";
    } catch {
      return "";
    }
  }

  // CodeScanner registration of the dynamic keys below:
  // $t("Good morning") $t("Good afternoon") $t("Good evening")
  get greetingKey(): string {
    const hour = new Date().getHours();
    if (hour < 12) {
      return "Good morning";
    }
    if (hour < 20) {
      return "Good afternoon";
    }
    return "Good evening";
  }

  mounted() {
    this.settings = store.state.settings;
  }

  close() {
    this.$emit("close");
  }

  openLogin(register: boolean) {
    LocalStorage.add("loginModeOn", register);
    this.close();
    store.commit("openLogin");
  }

  logout() {
    this.close();
    new ShopService().removeCart();
    CustomerHelper.logOut();
    window.location.reload();
  }
}
